var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoDireccin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono direcci\xC3\xB3n"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 23",
    cx: 12.1875,
    cy: 12.1876,
    r: 12.1876,
    fill: "#646363"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0424 5C9.25829 5 6.99998 7.25831 6.99998 10.0425C6.99998 12.417 10.6697 16.7178 11.7491 17.9299C11.9096 18.1071 12.1808 18.1071 12.3413 17.9299C13.4207 16.7178 17.0904 12.417 17.0904 10.0425C17.0849 7.25831 14.8266 5 12.0424 5ZM12.0424 12.2952C10.6697 12.2952 9.54612 11.1771 9.54612 9.79891C9.54612 8.42621 10.6642 7.30259 12.0424 7.30259C13.4151 7.30259 14.5388 8.42067 14.5388 9.79891C14.5388 11.1771 13.4207 12.2952 12.0424 12.2952Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoDireccin);
export default __webpack_public_path__ + "static/media/icono-dirección.e8e9b4d982667d98d1ed3e4ecdf01b4e.svg";
export { ForwardRef as ReactComponent };